var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCustomApi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.668 6.5V2c0-.368.298-.667.667-.667H10v3.334h3.334V14a.667.667 0 01-.667.667h-7M10 1.333l3.333 3.334",
    stroke: "#000",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10h4",
    stroke: "#5089FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8l2 2-2 2",
    stroke: "#5089FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMi42Njc5NyA2LjVWMS45OTk5MkMyLjY2Nzk3IDEuNjMxNzMgMi45NjY0NSAxLjMzMzI1IDMuMzM0NjQgMS4zMzMyNUgxMC4wMDEzVjQuNjY2NTlIMTMuMzM0NlYxMy45OTk5QzEzLjMzNDYgMTQuMzY4MSAxMy4wMzYyIDE0LjY2NjYgMTIuNjY4IDE0LjY2NjZIOC4wMDEzSDUuNjY3OTciIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICA8cGF0aCBkPSJNMTAgMS4zMzMzMUwxMy4zMzMzIDQuNjY2NjUiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICA8cGF0aCBkPSJNMi41IDEwSDYuNSIgc3Ryb2tlPSIjNTA4OUZGIiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgPHBhdGggZD0iTTUuNSA4TDcuNSAxMEw1LjUgMTIiIHN0cm9rZT0iIzUwODlGRiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgPC9zdmc+CiAg";
export { SvgIconCustomApi as ReactComponent };